import { Box, Button, CardContent, styled, Typography } from '@mui/material';
import { FlexContainer } from '@/components/Layout/Container';
import { FunctionComponent } from 'react';

export const ConditionPreviewContainer = styled(FlexContainer)(() => ({
    alignItems: 'center',
    width: '100%',
    height: 124,
}));

export const ConditionInfoContainer = styled(CardContent)(() => ({
    display: 'flex',
    flexGrow: 1,
}));

export const IconButtonContainer = styled(Button)(({ theme }) => ({
    alignItems: 'center',
    borderLeft: `1px solid ${theme.palette.grey['200']}`,
    borderRadius: 0,
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    transition: 'all 250ms ease-out',
    width: 64,

    '&:hover': {
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.text.primary,
    },
}));

export const IconButtonTop = styled(IconButtonContainer)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.grey['200']}`,
}));

export const SplitIconContainer = styled(FlexContainer)(() => ({
    flexDirection: 'column',
    height: '100%',
}));

export const SortNumberContainer = styled(FlexContainer)(({ theme }) => ({
    backgroundColor: theme.palette.grey['200'],
    borderRight: `1px solid ${theme.palette.grey['200']}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 56,
    height: '100%',
}));

export const FormHeader: FunctionComponent<{
    title: string;
    subtitle: React.ReactNode;
}> = ({ title, subtitle }) => {
    return (
        <Box
            sx={(theme) => ({
                p: 6,
                backgroundColor: theme.palette.primary.main,
                color: '#fff',
            })}
        >
            <Typography
                sx={{
                    mb: 3,
                }}
                variant='h5'
            >
                {title}
            </Typography>

            <Typography>{subtitle}</Typography>
        </Box>
    );
};

export const DeleteButtonTile = styled(IconButtonContainer)(({ theme }) => ({
    backgroundColor: '#fff',

    '&:hover': {
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.text.primary,
        },
    },
}));
